// LIBRARIES
import styled, { css } from "styled-components";

// MISC
import { COLORS, FONTS } from "constants/styleVariables";

export const NewcomeUserContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-bottom: 10px;
  margin-top: 9px;
  margin-right: 20px;
  border-bottom: 1px solid ${COLORS.backgroundColor};
`;

export const VerticalLine = styled.div`
  width: 4px;
  height: 50px;
  border-radius: 10px;
  background-image: linear-gradient(
    180deg,
    ${COLORS.rainbowIndigo} 0%,
    ${COLORS.rainbowIndigo} 100%
  );
  margin-right: 22px;
`;

export const UserImage = styled.img`
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: ${COLORS.backgroundColor};
`;

export const ClickableContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const UserInfo = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 20px;
`;

export const UserName = styled.div`
  font-size: 18px;
  font-weight: bold;
  color: ${COLORS.cornflowerBlue};
  font-family: ${FONTS.newsharp};
`;

export const UserStatus = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 5px;
  font-family: ${FONTS.montserrat};
`;

export const Dot = styled.div(
  ({ color }) => css`
    width: 9px;
    height: 9px;
    border-radius: 50%;
    background-color: ${color ? color : "transparent"};
  `
);

export const StatusValue = styled.div(
  ({ color }) => css`
    color: ${color ? color : "transparent"};
    margin-left: 10px;
    font-size: 14px;
  `
);

export const NewComeUserContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const DetailsButton = styled.div`
  width: 74px;
  height: 34px;
  border: 2px solid ${COLORS.rainbowIndigo};
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-family: ${FONTS.newsharp};
  color: ${COLORS.rainbowIndigo};
  cursor: pointer;
`;
